import { Navbar } from 'framework7-react';
import classnames from 'classnames';
import React      from 'react';


export default function TabPage({ name, title, children, className }) {
  const classNames = classnames('page', className);
  return (
    <div className={classNames} data-name={name}>
      <Navbar title={title}/>
      {children}
    </div>
  );
}
